export default "__VITE_ASSET__G1MW9Yr8__"